<template>
    <div class="container">
        <div class="row">
            <div class="col col-4">
                <h2 class="h h--2 h--dark">Zmień hasło</h2>
                <p class="paragraph">Wprowadź nowe hasło</p>
            </div>
            <div class="col col-8">
                <div class="row profile">
                    <div class="col col-12">
                        <form method="post" class="form" v-bind:class="{pending: pending}" @submit="send">
                            <div class="alert alert-danger" role="alert" v-if="error">
                            {{ error }}
                            </div>
                            <div class="form__input-container">
                                <input type="password" name="password" v-model="form.password" class="form__input" placeholder="Nowe hasło" required>
                            </div>
                            <div class="form__input-container">
                                <input type="password" name="password_confirmation" v-model="form.password_confirmation" class="form__input" placeholder="Powtórz nowe hasło" required>
                            </div>
                            <div class="form__input-container">
                                <button type="submit" class="button button--blue form__submit" v-bind:disabled="pending">Zapisz &raquo;</button>
                            </div>
                        </form>                        
                    </div>
                </div>
            </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'ChangePasswordComponent',
  data() {
      return {
        form: {
            password: '',
            password_confirmation: ''
        },
        error: '',
        pending: false
      }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  methods: {      
    send: function (e) {
      e.preventDefault()

      let vm = this
      vm.error = ''
      vm.pending = true

      var formData = new FormData()      
      formData.append('password', this.form.password)
      formData.append('password_confirmation', this.form.password_confirmation)

      Vue.axios({
          method: 'post',
          url: '/users/' + this.$store.state.user.id,
          data: formData
      })
      .then(response => {
        if( response.data.data.user.address_id ) {
          this.$toaster.success(response.data.message)
          this.$router.push('/')
        }
      })
      .catch(error => {    
        Object.keys(error.response.data.errors).forEach(function(err, eindex, earray) {
            error.response.data.errors[err].forEach(function(msg, mindex, marray) {
                vm.$toaster.error(msg)
            })
        });    
        
        vm.pending = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/user/ChangePasswordComponent.vue